import React, { Component } from 'react';
import InputField from './input-field.jsx'
import LoginStore from '../stores/login-store.js';
import dispatcher from '../dispatcher.js';
import debounce from 'lodash.debounce';
import { Auth } from 'aws-amplify';

class ChangePasswordForm extends Component {

	constructor(props) {
		super(props);
		this.state = Object.assign({
			isSubmitting: false
		},LoginStore.getAll());
		this.newUser = LoginStore.getUser();
		this.getFields = this.getFields.bind(this);
		this.validatePassword = debounce(this.validatePassword.bind(this), 500);
		this.onChangePassword = this.onChangePassword.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.resetStatus = this.resetStatus.bind(this);
	}

	componentDidMount() {
		LoginStore.on('change', this.getFields);
	}

	getFields() {
		this.setState(LoginStore.getAll());
	}

	componentWillUnmount() {
		LoginStore.removeListener('change', this.getFields);
	}

	onChangePassword(event) {
		dispatcher.dispatch({
			type: 'set_password',
			email: event.target.value
		});
		this.validatePassword(event.target.value);
		// eslint-disable-next-line
		if(this.state.email.value && this.state.email.value.length && this.state.email.class == 'is-warning') {
			this.onChangeEmail({target: this.state.email});
		} 
	}

	validatePassword(newPassword) {
		dispatcher.dispatch({
			type: 'validate_password',
			email: newPassword
		});					
	}
	resetStatus(event) {
		dispatcher.dispatch({
			type: 'reset_status'
		});					
	}

	onSubmit(event) {
		event.preventDefault();
		if(this.newUser == null) {
			return;
		}
		this.setState({
			isSubmitting: true
		}, () => {
			//Completo l'autenticazione
			Auth.completeNewPassword(this.newUser, this.state.password.value)
			.then((user) => {
				this.setState({isSubmitting: false});
				dispatcher.dispatch({
					type: 'user_logged',
					user: user
				});
				this.props.history.push('/');
			})
			.catch((err) => {
				this.setState({isSubmitting: false});
				console.error(err);
				switch(err.code) {
					case 'InvalidPasswordException':
					dispatcher.dispatch({
						type: 'invalidPasswordSubmitted'
					});
						break;
					default:
						break;
				}
			})
		})
	}

	render() {
		const btnClass = this.state.isSubmitting ? "button is-info is-medium is-loading" : "button is-info is-medium"
		const btnDisabled = this.state.password.class !== 'is-success';
		return (
			<div className="box">
				<form onSubmit={this.onSubmit}>
					<InputField type="password" label="Password" name="password" validationClass={this.state.password.class} validationMessage={this.state.password.message} value={this.state.password.value} onChange={this.onChangePassword}/>
					<div className="field">
						<div className="control">
							<button className={btnClass} onClick={this.onSubmit} disabled={btnDisabled}>Conferma nuova password</button>
						</div>
					</div>
				</form>
			</div>
		)
	}
}

export default ChangePasswordForm


// WEBPACK FOOTER //
// ./src/components/password-form.jsx